import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useParams } from "react-router-dom";
import DynamicForm from "../../Components/DynamicForm";
import Particle from "../../Components/Particle";
import { END_POINT_MEMBERS } from "../../Config";
import { registrationForm } from "../../Constants";


function Register() {
  const [step, setStep] = useState(0);
  const [formData, setFromData] = useState({})
  const [isShowUpload,setShowUpload]=useState(false)
  const { profileUrl } = useParams();
  
  function handleSubmit() {
    if (step < registrationForm.length - 1) {
      setStep(step + 1)
    }else{
      axios.post(END_POINT_MEMBERS,formData)
    }
  }

  async function makeApiCall(){
    const response = await axios.get(END_POINT_MEMBERS+'/'+profileUrl);
    setFromData(response.data.data)
  }

  useEffect(() => {
    if(profileUrl){
    makeApiCall()
    }
  }, [profileUrl])

  function handlePrevious() {
      setStep(step -1)
  }
  function handleUpload(e){
    setShowUpload(!isShowUpload)
    e.preventDefault()
  }

  function onChange(data,formName){
    let formDataT={...formData,...data}
    setFromData(formDataT)
  }
  return (
    <section>
      <div className="home-about-section w-full" id="home">
        <Particle />
        <div className="home-content">
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:w-6/12">
              <div className="bg-gray-700 rounded shadow-lg">
                <div className="px-4 py-2 border-b border-gray-600 font-semibold text-white">Registration</div>
                <div className="p-4">
                  <h5 className="text-white font-semibold mb-3">{registrationForm[step].label}</h5>
                  <form>
                    {registrationForm[step].config.map((item) => {
                      return <DynamicForm
                        key={item.fieldName}
                        formConfig={{...item,onChange,formName:registrationForm[step].formName}}
                        isShowUpload={isShowUpload}
                        setShowUpload={handleUpload}
                        formData={formData}
                      />
                    })}
                    <div className="loginButtonWrapper">
                      <button type="button" className="pull-right1 px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 mr-2" onClick={handlePrevious} disabled={step === 0}>
                        Previous
                      </button>
                      <button type="button" className="pull-right px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700" onClick={handleSubmit}>
                        {step === registrationForm.length-1 ? 'Submit' : 'Next'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Register;
